import { Component } from '@angular/core';

@Component({
  selector: 'bc-user-required-modal',
  templateUrl: './user-required.modal.component.html',
  styleUrls: ['./user-required.scss'],
  standalone: false,
})
export class UserRequiredModalComponent {}
